import { RoomId, RoomMixerStreamEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const init = createAction("[Room Mixer Stream] Init");
export const destroy = createAction("[Room Mixer Stream] Destroy");

export const dispose = createAction("[Room Mixer Stream] Dispose");
export const reset = createAction("[Room Mixer Stream] Reset");

export const roomMixerStreamGet = createAction(
  "[Room Mixer Stream] Get",
  props<{ roomId: RoomId }>()
);
export const roomMixerStreamGetSuccess = createAction(
  "[Room Mixer Stream] Get Success",
  props<{ stream: null | RoomMixerStreamEntity }>()
);
export const roomMixerStreamGetFailure = createAction(
  "[Room Mixer Stream] Get Failure"
);
